// Shared contract for the invoice "Description" (customer notes) field.
//
// The same rule is checked from five places — Preview, Save as draft, Send Invoice,
// Edit Request and the wizard's step summary — and the Other Details card needs to
// react when any of them rejects it. Keeping the rule and the signal here means the
// card doesn't have to know which action failed.

export const DESCRIPTION_MIN_CHARS = 20;
export const DESCRIPTION_MIN_WORDS = 3;

/** Valid once it has at least 20 characters OR at least 3 words. */
export const isDescriptionValid = (value?: string | null): boolean => {
  const text = (value || '').trim();
  if (!text) return false;
  const words = text.split(/\s+/).filter(Boolean).length;
  return text.length >= DESCRIPTION_MIN_CHARS || words >= DESCRIPTION_MIN_WORDS;
};

const INVALID_DESCRIPTION_EVENT = 'invozio:invoice-description-invalid';

/**
 * Ask the Other Details card to turn the Description field red and scroll to it.
 * Call this next to the existing toast when an action is blocked by the rule.
 */
export const flagInvalidDescription = (): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(INVALID_DESCRIPTION_EVENT));
};

/** Subscribe to the above. Returns an unsubscribe function. */
export const onInvalidDescription = (handler: () => void): (() => void) => {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(INVALID_DESCRIPTION_EVENT, handler);
  return () => window.removeEventListener(INVALID_DESCRIPTION_EVENT, handler);
};
